import { Observable } from 'rxjs';
import { ignoreElements, map, tap, withLatestFrom } from 'rxjs';
import { CartActions, CartState, TypeMap as CartTypeMap } from 'src/core/state/cart';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { fireGtm } from 'src/features/analytics/hooks/useGtm';

export function gtmRemoveFromCart(action$: Observable<any>, state$: Observable<any>): Observable<never> {
    const cartItems$: Observable<CartState['items']> = state$.pipe(map((s) => s?.cart?.items));

    return action$.pipe(
        ofType<CartActions, CartTypeMap['Cart.ItemDelete']>('Cart.ItemDelete'),
        withLatestFrom(cartItems$),
        tap(([{ payload }, items]) => {
            const product = items.find((item) => item.id === payload.itemId.toString());
            fireGtm({
                event: 'eec.remove',
                eecEventName: 'Remove from Cart',
                ecommerce: {
                    remove: {
                        actionField: {
                            list: '',
                        },
                        products:
                            (product && [
                                {
                                    id: product.product.sku,
                                    name: product.product.name,
                                    price: product.prices.price,
                                },
                            ]) ||
                            [],
                    },
                },
            });
        }),
        ignoreElements(),
    );
}
